module.exports = "<h2>Relevant places for travel</h2> <crud-whereabout-curate></crud-whereabout-curate> <h2>Geofences (to be able to match GPS data with the places for travel)</h2> <crud-location-curate></crud-location-curate> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/subsections/whereabouts/inspect.travels.whereabouts.html
// module id = 4185
// module chunks = 86